import React from 'react';
import clsx from 'clsx';
import { useFeatures } from '@atc/features';
import { SubHeading, Button, Glyphicon, Text } from 'reaxl';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
function Title(_ref) {
  let {
    onClick = () => {},
    enableTitleLink = false,
    uiContext = 'default',
    showIcon = true
  } = _ref;
  const {
    srp_wallet_grid_update: [enableUpdatedWalletGrid, {
      with_kbb_grid_upgrade: withKbbGridUpdate,
      without_kbb_logo: withoutKbbLogo
    }],
    global_kbb_branded_wallet: [enableKbbBrandedWallet, {
      hide_kbb_branding: hideKbbBranding
    }]
  } = useFeatures(['srp_wallet_grid_update', 'global_kbb_branded_wallet']);
  const isBasicGrid = uiContext === 'basic';
  let glyphClassNames = '';
  if (isBasicGrid) {
    glyphClassNames = 'text-accent';
  }
  if (withKbbGridUpdate) {
    glyphClassNames = 'wallet-grid-hdr-blue';
  }
  if (uiContext === 'default' || isBasicGrid) {
    const sharedClasses = 'display-inline-block';
    const textSizeClassName = isBasicGrid ? 'text-size-500' : '';
    const kbbTextColor = withKbbGridUpdate ? 'wallet-grid-hdr-blue' : '';
    return /*#__PURE__*/jsx(SubHeading, {
      level: "4",
      children: /*#__PURE__*/jsxs(Button, {
        className: clsx({
          'cursor-pointer': !isBasicGrid
        }, 'user-icon display-flex align-items-center'),
        bsStyle: "text",
        onClick: onClick,
        children: [!isBasicGrid && /*#__PURE__*/jsxs(React.Fragment, {
          children: [/*#__PURE__*/jsxs("span", {
            className: clsx(sharedClasses, kbbTextColor),
            children: ["Kelley Blue Book", /*#__PURE__*/jsx("sup", {
              children: "\xAE"
            })]
          }), /*#__PURE__*/jsx("span", {
            className: clsx(sharedClasses, kbbTextColor, 'margin-left-2 margin-right-3'),
            children: "|"
          })]
        }, "title-my-wallet-grid-key"), /*#__PURE__*/jsx(Glyphicon, {
          className: clsx('margin-right-2 align-self-center', glyphClassNames),
          glyph: "wallet",
          style: {
            marginBottom: '2px'
          }
        }), /*#__PURE__*/jsx("span", {
          className: clsx({
            '': enableUpdatedWalletGrid
          }, kbbTextColor, textSizeClassName, sharedClasses),
          children: "My Wallet"
        })]
      })
    });
  }
  if (enableKbbBrandedWallet) {
    const heading = /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(Glyphicon, {
        className: "text-size-500",
        glyph: "wallet"
      }), ' ', /*#__PURE__*/jsx(Text, {
        size: 500,
        children: "My Wallet"
      }), !hideKbbBranding && /*#__PURE__*/jsxs(Fragment, {
        children: [' ', /*#__PURE__*/jsxs(Text, {
          size: 300,
          weight: "light",
          children: ["by Kelley Blue Book", /*#__PURE__*/jsx("span", {
            className: "text-valign-super text-size-100",
            children: "\xAE"
          })]
        })]
      })]
    });
    return /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx("div", {
        className: clsx('margin-vertical-4', {
          inverted: enableTitleLink
        }),
        children: enableTitleLink ? /*#__PURE__*/jsx(Button, {
          bsStyle: "text",
          onClick: onClick,
          children: heading
        }) : heading
      }), !hideKbbBranding && showIcon && !withoutKbbLogo && /*#__PURE__*/jsx("img", {
        height: "31",
        width: "130",
        src: "https://www.kbb.com/content/static/img/partner/kbb/KBB_Logo_Rev_White_RGB_Small.svg",
        className: "margin-left-auto margin-right-5",
        alt: ""
      })]
    });
  }
  return /*#__PURE__*/jsx(Fragment, {
    children: "My Wallet"
  });
}
export { Title as default };
